import topDealsReducer from "./topDealsReducer";

export * from "./topDealsActions";
export default topDealsReducer;
